import { render } from "./Permissions.vue?vue&type=template&id=2c711ef4&scoped=true&ts=true"
import script from "./Permissions.vue?vue&type=script&lang=ts"
export * from "./Permissions.vue?vue&type=script&lang=ts"

import "./Permissions.vue?vue&type=style&index=0&id=2c711ef4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c711ef4"]])

export default __exports__